import { defineMessages } from 'react-intl'

export interface facetMessage {
  id: string
  defaultMessage: string
}

export const accountMenuMessages = defineMessages({
  YOUR_PROFILE: { id: 'YOUR_PROFILE', defaultMessage: 'Profile' },
  PRIMARY_NAV_ACCOUNT: { id: 'PRIMARY_NAV_ACCOUNT', defaultMessage: 'Account' },
  YOUR_ORDERS: { id: 'YOUR_ORDERS', defaultMessage: 'Orders' },
  YOUR_QUOTES: { id: 'YOUR_QUOTES', defaultMessage: 'Quotes' },
  SAVED_CARTS: { id: 'SAVED_CARTS', defaultMessage: 'Saved Carts' },
  BUY_IT_AGAIN: { id: 'BUY_IT_AGAIN', defaultMessage: 'Buy It Again' },
  LISTS: { id: 'LISTS', defaultMessage: 'Lists' },
  SUBSCRIPTIONS: { id: 'EMPROVE_PROGRAM', defaultMessage: 'Emprove® Program' },
})

export default accountMenuMessages
